import React, { Component } from 'react';
import { headers,BaseURLDev } from '../../../../../_utils/config';
import { messageGagal } from '../../../../../_utils/message';
import { terbilang } from '../../../../../_utils/terbilang';
import { toIDR } from '../../../../../_utils/tocurrency';
import { Menu, Form, Select,Table,Grid,Segment } from 'semantic-ui-react';
import { fetchOPD, fetchSKPD, isAdmin } from '../../../../../_utils/localstorage';

const SKPDFilter = (props) => {

   function childFunc(kode,name){
      props.toChild(kode===10000?null:kode,name)
   }
  
   return (
      <Form>
         <Form.Field 
            placeholder="---Pilih SKPD---"  
            control={Select} 
            loading={props.load}
            search
            disabled={props.load}            
            onChange={(e,el)=>childFunc(el.options[el.value].key,el.options[el.value].text)} 
            options={props.data}
            style={{width:'300px'}}
         />
      </Form>
   )
}

const OPDFilter = (props) => {

   function childFunc(kode,name){
      props.toChild(kode===10000?null:kode,name)
   }
   return (
      <Form>
         <Form.Field 
            placeholder="---Pilih OPD---"  
            control={Select} 
            loading={props.load}
            search
            disabled={props.load}            
            onChange={(e,el)=>childFunc(el.options[el.value].key,el.options[el.value].text)} 
            options={props.data}
            style={{width:'300px'}}
         />
      </Form>
   )
}

export default class KalkulasiSTS extends Component {
   constructor(props){
      super(props);
      this.state = {
         verified:{
            hari_ini:null,
            bulan_ini:null,
            januari_sd_bulan_lalu:null,
            januari_sd_bulan_ini:null,
            requests:true         
         },

         unverified:{
            hari_ini:null,
            bulan_ini:null,
            januari_sd_bulan_lalu:null,
            januari_sd_bulan_ini:null,
            requests:true
         },

         skpds:[],
         skpd_kode:null,
         skpd_name:null,

         opds:[],
         opd_kode:null,
         opd_name:null,

         activeIndex: 0,
         
      }
      this.getUnVerified = this.getUnVerified.bind(this);
      this.getVerified = this.getVerified.bind(this);
      this.filterDataBySKPD = this.filterDataBySKPD.bind(this);
      this.filterDataByOPD = this.filterDataByOPD.bind(this);
      this.resetStatusRequest = this.resetStatusRequest.bind(this);
      this.allData = this.allData.bind(this);
   }

   skpdSelect(){
      if(fetchSKPD().length!==0){
         const skpds = []
         skpds.push({'value':0,'text':"Semua Data",'key':10000})                  
         for(let i=0; i<fetchSKPD().length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${fetchSKPD()[i].kode_skpd}] ${fetchSKPD()[i].skpd}`,
               'key': fetchSKPD()[i].kode_skpd,     
            })
         }
         this.setState({skpds:skpds})
      }
   }

   opdSelect(){
      if(fetchOPD().length!==0){
         const opds = []
         opds.push({'value':0,'text':"Semua Data",'key':10000})                  
         for(let i=0; i<fetchOPD().length; i++) {
            opds.push({
               'value': i+1,
               'text': `[${fetchOPD()[i].kode_opd}] ${fetchOPD()[i].opd}`,
               'key': fetchOPD()[i].kode_opd,     
            })
         }
         this.setState({opds:opds})
      }
   }

   resetStatusRequest = () => this.setState({
      verified:{...this.state.verified,requests:true},
      unverified:{...this.state.unverified,requests:true}
   })

   allData(){
      this.resetStatusRequest()
      this.getVerified(null,null)
      this.getUnVerified(null,null)
   }
   
   filterDataBySKPD(kode,name){
      this.setState({label:name}) 
      this.resetStatusRequest()
      this.getVerified(kode,null)
      this.getUnVerified(kode,null)
   }

   filterDataByOPD(kode,name){
      this.setState({label:name}) 
      this.resetStatusRequest()
      this.getVerified(null,kode)
      this.getUnVerified(null,kode)
   }

   getVerified(skpd,opd){
      fetch(`${BaseURLDev}/report/sts/realisasi?skpd=${skpd}&opd=${opd}`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         this.setState({
            verified:{
               ...this.state.verified,
               hari_ini:resJSON.hari_ini,
               bulan_ini:resJSON.bulan_ini,
               januari_sd_bulan_lalu:resJSON.januari_sd_bulan_lalu,
               januari_sd_bulan_ini:resJSON.januari_sd_bulan_ini,
               requests:false
            }
         })
      })
   }

   getUnVerified(skpd,opd){
      fetch(`${BaseURLDev}/report/sts/summaryunverified?skpd=${skpd}&opd=${opd}`, { headers })
      .then(response => {
         if(!response.ok){
            messageGagal("Load data gagal")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         this.setState({
            unverified:{
               ...this.state.unverified,
               hari_ini:resJSON.hari_ini,
               bulan_ini:resJSON.bulan_ini,
               januari_sd_bulan_lalu:resJSON.januari_sd_bulan_lalu,
               januari_sd_bulan_ini:resJSON.januari_sd_bulan_ini,
               requests:false  
            }
         })
      })
   }

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data SKPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const opds = []
         opds.push({'value':0,'text':"Semua Data",'key':10000})                  
         for(let i=0; i<resJSON.data.length; i++) {
            opds.push({
               'value': i+1,
               'text': `[${resJSON.data[i].kode_opd}] ${resJSON.data[i].opd}`,
               'key': resJSON.data[i].kode_opd,     
            })
         }
         this.setState({opds:opds})
      })
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            // messageGagal("Load data OPD gagal dari SIMDA")            
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const skpds = []
         skpds.push({'value':0,'text':"Semua Data",'key':10000})                  
         for(let i=0; i<resJSON.data.length; i++) {
            skpds.push({
               'value': i+1,
               'text': `[${resJSON.data[i].kode_skpd}] ${resJSON.data[i].skpd}`,
               'key': resJSON.data[i].kode_skpd,     
            })
         }
         this.setState({skpds:skpds})
      })
   }

   componentDidMount(){
      this.getUnVerified(null,null)
      this.getVerified(null,null)
      if(fetchSKPD().length===0){
         this.getDataSKPD()
      }else if(fetchOPD().length===0){
         this.getDataOPD()
      }else{
         if(isAdmin()){
            this.skpdSelect();
            this.opdSelect();
         }
      }
   }

   handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
  
      this.setState({ activeIndex: newIndex })
   }

   render() {
      const {verified,unverified} = this.state

      return (
         <div>
            {/*{(verified.requests || unverified.requests) ? <Loader active inline='centered' size='medium'>Loading...</Loader>:         */}
            <Grid>
                  {isAdmin() &&
                  <Grid.Column width={16}>
                  <Menu>
                     <Menu.Item>
                        <SKPDFilter
                           allData={this.allData}
                           data={this.state.skpds} 
                           disabledBtn={this.state.skpd_kode}
                           toChild={(kode,name)=>this.filterDataBySKPD(kode,name)}
                           load={this.state.requestsSKPD}
                        />
                     </Menu.Item>
                     <Menu.Item>
                        <OPDFilter
                           allData={this.allData}
                           data={this.state.opds} 
                           disabledBtn={this.state.opd_kode}
                           toChild={(kode,name)=>this.filterDataByOPD(kode,name)}
                           load={this.state.requestsOPD}                                 
                        />
                     </Menu.Item>
                     <Menu.Item>
                        <div style={{width:'300px'}}>{this.state.label}</div>
                     </Menu.Item>
                  </Menu> 
               </Grid.Column>            
                  }
               <Grid.Column width={16}><Segment>
                  <Table size='small' id="print_data" celled>
                     <Table.Header> 
                     <Table.Row>
                        <Table.HeaderCell style={{width:"50%"}} colSpan="4">Realisasi</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"50%"}} colSpan="4">STS</Table.HeaderCell>
                     </Table.Row>
                     <Table.Row>
                        <Table.HeaderCell style={{width:"12%"}}>hari ini</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"12%"}}>bulan ini</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"12%"}}>januari s/d bulan lalu</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"14%"}}>januari s/d bulan ini</Table.HeaderCell>

                        <Table.HeaderCell style={{width:"12%"}}>hari ini</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"12%"}}>bulan ini</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"12%"}}>januari s/d bulan lalu</Table.HeaderCell>
                        <Table.HeaderCell style={{width:"14%"}}>januari s/d bulan ini</Table.HeaderCell>
                     </Table.Row>
                     </Table.Header> 
                     <Table.Body>
                        <Table.Row>
                           <Table.Cell>{verified.requests ? "Request...": toIDR(verified.hari_ini)}</Table.Cell>
                           <Table.Cell>{verified.requests ? "Request...": toIDR(verified.bulan_ini)}</Table.Cell>
                           <Table.Cell>{verified.requests ? "Request...": toIDR(verified.januari_sd_bulan_lalu)}</Table.Cell>
                           <Table.Cell>{verified.requests ? "Request...": toIDR(verified.januari_sd_bulan_ini)}</Table.Cell>

                           <Table.Cell>{unverified.requests ? "Request...": toIDR(unverified.hari_ini)}</Table.Cell>
                           <Table.Cell>{unverified.requests ? "Request...": toIDR(unverified.bulan_ini)}</Table.Cell>
                           <Table.Cell>{unverified.requests ? "Request...": toIDR(unverified.januari_sd_bulan_lalu)}</Table.Cell>
                           <Table.Cell>{unverified.requests ? "Request...": toIDR(unverified.januari_sd_bulan_ini)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                           <Table.Cell colSpan="3">Sub Total</Table.Cell>
                           <Table.Cell>{toIDR(verified.januari_sd_bulan_ini)}</Table.Cell>

                           <Table.Cell colSpan="3">Sub Total</Table.Cell>
                           <Table.Cell>{toIDR(unverified.januari_sd_bulan_ini)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                           <Table.Cell colSpan="7">Total</Table.Cell>
                           <Table.Cell>{toIDR(unverified.januari_sd_bulan_ini+verified.januari_sd_bulan_ini)}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                           <Table.Cell colSpan="8">{
                              (verified.requests || unverified.requests) ? "Request...":
                              terbilang(unverified.januari_sd_bulan_ini+verified.januari_sd_bulan_ini)==='rupiah' ? "_____________" : terbilang(unverified.januari_sd_bulan_ini+verified.januari_sd_bulan_ini)
                           }</Table.Cell>
                        </Table.Row> 
                     </Table.Body>               
                  </Table></Segment>
               </Grid.Column>
               </Grid>
   {/*}}*/}
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/KalkulasiSTS.js